var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEditDetailHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_edit_detail_hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_edit_detail_hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18-Copy-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7017981,0.503797797 C14.9562956,0.503640407 17.8518192,1.73382032 19.96023,3.73766445 C22.0909718,5.76273219 23.416749,8.57700257 23.4962057,11.7017525 C23.4983302,15.1177437 22.2573087,17.9532877 20.2352999,20.0273796 C18.2112782,22.1035363 15.4085538,23.4171238 12.2981588,23.4962057 C8.8293166,23.4982782 5.95077479,22.2147772 3.86791396,20.1319164 C1.78702293,18.0510254 0.5,15.176159 0.5,12 C0.5,8.87711311 1.74441476,6.04494446 3.76470005,3.97262043 C5.78872182,1.89646367 8.59144621,0.582876234 11.7017981,0.503797797 Z",
    id: "Rectangle-729",
    stroke: "#D1D7DA",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,15.5003472 L6,18 L8.49965283,18 L15.8719622,10.6276906 L13.3723094,8.12803777 L6,15.5003472 L6,15.5003472 Z M17.8050271,8.69462575 C18.064991,8.43466185 18.064991,8.01472018 17.8050271,7.75475628 L16.2452437,6.19497292 C15.9852798,5.93500903 15.5653381,5.93500903 15.3053743,6.19497292 L14.0855437,7.4148035 L16.5851965,9.91445633 L17.8050271,8.69462575 L17.8050271,8.69462575 Z",
    id: "Shape",
    fill: "#5697B7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditDetailHover);
export default __webpack_public_path__ + "static/media/icon_edit_detail_hover.ea58e77adf181db890ea3be504ec91b8.svg";
export { ForwardRef as ReactComponent };